export default "__VITE_ASSET__Cpcwh9Kx__"